module.exports = __webpack_public_path__ + "img/left_gk.8c645b97.png";